export default __webpack_public_path__ + "assets/images/TriumphLogo.f3a22977fc64a8c30d5463b0e22ac89d.png";